import { type FC } from 'react';
import PenIcon from 'dibs-icons/exports/legacy/Pen.ts';

import styles from './Pen.module.css';

const Pen: FC = () => {
    return <PenIcon className={styles.icon} />;
};

export default Pen;
